// extracted by mini-css-extract-plugin
export default {"container":"cm_g","name":"cm_jZ","address":"cm_j0","phone":"cm_j1","email":"cm_j2"};